exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports
exports.i(require("-!../../../../node_modules/css-loader/index.js??ref--6-oneOf-1-1!../../../../node_modules/vue-loader/lib/loaders/stylePostLoader.js!../../../../node_modules/postcss-loader/src/index.js??ref--6-oneOf-1-2!../css/general.css"), "");

// module
exports.push([module.id, "\n.root-layout[data-v-2e74e84f] {\r\n  padding: 30px;\n}", ""]);

// exports
